/* tslint:disable */
/* eslint-disable */
/**
 * Pfa API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  PersonRegisterDto,
} from '../models/index';
import {
    PersonRegisterDtoFromJSON,
    PersonRegisterDtoToJSON,
} from '../models/index';

export interface ApiPersonRegisterPostRequest {
    personRegisterDto?: PersonRegisterDto;
}

/**
 * 
 */
export class PersonRegisterApi extends runtime.BaseAPI {

    /**
     */
    async apiPersonRegisterPostRaw(requestParameters: ApiPersonRegisterPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // ApiKey authentication
        }

        const response = await this.request({
            path: `/api/PersonRegister`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PersonRegisterDtoToJSON(requestParameters['personRegisterDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiPersonRegisterPost(requestParameters: ApiPersonRegisterPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiPersonRegisterPostRaw(requestParameters, initOverrides);
    }

}
